<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>宿舍管理->{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="寄宿生考勤" name="first">
                <child1></child1>
            </el-tab-pane>
    
            <el-tab-pane label="寄宿生历史考勤" name="second">
                <child2></child2>    
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import boarderAttendance from './Attendance'
    import boarderAttendanceHistory from './AttendanceHistory'

    export default {
        name:"BoarderAttendanceHistory",
        components:{
            child1:boarderAttendance,
            child2:boarderAttendanceHistory
        },
        data() {
            return {
                //默认第一个选项卡
                activeName: "first",
                title:"寄宿生考勤"
            }
        },
        methods:{
            handleClick(tab) {
                if(tab.name == "first") {
                    this.title="寄宿生考勤";
                } else if(tab.name == "second") {
                    this.title="寄宿生历史考勤";
                }
            }
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/hostel/boarderAttendance.vue